import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../../shared/category.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { Category } from '../../shared/category.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.css']
})
export class CategoryListComponent implements OnInit {

  category: Category[];
  constructor(
    private service:CategoryService,
    private firestore:AngularFirestore,
    private toastr : ToastrService) { }

  ngOnInit() {
    this.service.getCategory().subscribe(actionArray =>{
      this.category = actionArray.map(item => {
        const data = item.payload.doc.data() as Category;
        const id = item.payload.doc.id;
        return { id, ...data };
      })
    });
  }

  onEdit(cat:Category){
    this.service.categoryData = Object.assign({},cat);
  }

  onDelete(id: string){
    if(confirm("Are you sure to delete this Category?")){
      this.firestore.doc('category/' +id).delete();
      this.toastr.warning('Deleted Successfuly','Category');
    }
  }
}
